import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";

/**
 * Consistent error + retry state shown when a tab's primary data request
 * fails or times out. Replaces silent blank screens with an actionable UI.
 */
export default function TabLoadError({ onRetry, message }) {
  return (
    <div
      className="flex flex-col items-center justify-center py-20 text-center"
      data-testid="tab-load-error"
    >
      <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
        <AlertTriangle className="w-6 h-6 text-destructive" />
      </div>
      <p className="font-medium text-foreground">Couldn't load this view</p>
      <p className="text-sm text-muted-foreground mt-1 max-w-sm">
        {message ||
          "The request timed out or the server didn't respond. Your data is safe — please try again."}
      </p>
      <Button
        onClick={onRetry}
        variant="outline"
        size="sm"
        className="mt-4"
        data-testid="tab-load-error-retry"
      >
        <RefreshCw className="w-4 h-4 mr-2" /> Retry
      </Button>
    </div>
  );
}
